export default __webpack_public_path__ + "static/media/Preparing_for_Connect5_T4T.b03ffebf.pdf";